import {ajax, removePath, redirectPage} from '../../common/utils.js';
import {replace} from "react-router-redux";
import {
    LOAD_ITEMS, LOAD_CATEGORIES, STORE_CREDITS_DATA, SET_REMAINING_CREDITS,
    CHANGE_ITEM_QUANTITY, CHANGE_EXTRA_ITEM_QUANTITY,
    UPDATE_ITEMS_PROPS, UPDATE_TOTALS, SET_STORE_HAS_COUPONS, SET_WEB_ORDER_COUPON,
    SET_HAS_ALREADY_COUPON, SHOW_LOGIN_SIGNUP_MODAL, UPDATE_ITEMS_AVAILABILITY
} from '../actionTypes';
import {setDirty, setShouldReloadData} from '../common/commonActions';
import {fetchingData, dataFetched, errorFetching, isFetching} from '../common/fetchingActions';
import {setAllowOrderEditToStore, setSummary, subscriptionSummaryParser, setEditMultiOrder} from '../common/subscriptionSummaryActions';
import {setActiveOrder} from '../common/commonActions';
import {submitOrder, setUnavailableItemsInOrder} from './storeCheckoutActions';
import {messageDataParser, setMessageData} from "../common/messagePageActions";
import {increaseItemOrder} from '../../reducers/store/storeItemsListReducer';
import {FetchingTypes, FIELD_SELECTED_ORDER, FIELD_ADDITIONAL_ITEM_QTY, CreditTypes, SubscriptionStatuses, URLs, SubscriptionHoldReason, ORDER_KEY_CHANGED, PICKUP_SITE_KEY_CHANGED} from '../../common/constants';
import {getOrderedItemsForSummary, calculateOrderTotal, calculateOrderPoints} from "../../common/basket";
import {getCouponData, parseCouponData} from "../common/commonActions";
import {recurringOrderParser, setRecurringOrderData, setRecurringItem} from "./recurringOrderActions";
import {getStoreCloseMessage} from "../common/messagePageActions";
import {changeItemQuantity} from "./itemCardActions";
import {getDraftOrderFromStorage, setDraftOrderInStorage} from "../../common/storage";

export function loadItems(data) {
    return {
        type: LOAD_ITEMS,
        data: data
    };
}

export function loadCategories(categories) {
    return {
        type: LOAD_CATEGORIES,
        categories
    }
}

export function setStoreCreditsData(storeCreditsData) {
    return {
        type: STORE_CREDITS_DATA,
        storeCreditsData: storeCreditsData
    }
}

export function setStoreCreditsRemaining(remainingCredits) {
    return {
        type: SET_REMAINING_CREDITS,
        remainingCredits: remainingCredits
    }

}

export function changeItemQuantityAction(key, newQuantity) {
    return {
        type: CHANGE_ITEM_QUANTITY,
        key: key,
        newQuantity
    };
}

export function changeExtraItemQuantityAction(key, newQuantity) {
    return {
        type: CHANGE_EXTRA_ITEM_QUANTITY,
        key: key,
        newQuantity
    };
}

export function showLoginSignupModal(show) {
    return {
        type: SHOW_LOGIN_SIGNUP_MODAL,
        show: show,
    };
}

export function saveDraftOrder() {
    return function (dispatch, getState) {
        const state = getState();
        const orderStatus = state.orderStatus || {};
        const currentOrder = orderStatus.currentOrder || {};
        const itemsList = state.itemsList;
        const draftOrder = {};
        for (const draftItem of Object.values(currentOrder)) {
            const item = itemsList[draftItem.key] || {};
            draftOrder[draftItem.key] = Object.assign({}, item, {quantity: draftItem.quantity});
        }
        setDraftOrderInStorage(draftOrder);
    }
}

function loadDraftItems(store){
    return function(dispatch) {
        if ((store.messageData || {}).messageTitle) {
            return;
        }
        const draftOrder = getDraftOrderFromStorage();
        if (draftOrder) {
            if (store.activeOrder) {
                dispatch(setMessageData({
                    messageTitle: 'Order already exists',
                    messageBody: 'You already have an existing order. Click continue to make changes to it. The recent items you have added to the cart were not saved.',
                    allowContinue: true
                }));
                return;
            }
            let unavailableItems = {};
            for (const draftItem of Object.values(draftOrder)) {
                const item = store.items[draftItem.key];
                if (item) {
                    dispatch(changeItemQuantity(item, draftItem.quantity, 0));
                } else {
                    unavailableItems[draftItem.key] = draftItem.title;
                }
            }
            if (Object.keys(unavailableItems).length > 0) {
                dispatch(setMessageData({
                    messageTitle: 'Unavailable items',
                    messageBody: 'Due to inventory changes we could not restore the following items in your cart - ' + Object.values(unavailableItems).join(', '),
                    allowContinue: true
                }));
            }
        }
    }
}

export function loadData(initialData){
    return function(dispatch, getState){
        const state = getState();
        const fetchUrl = getFetchUrl(initialData.memberKey);
        let data = {
            farmKey: state.staticData.farmKey,
            memberKey: initialData.memberKey,
            seasonKey: state.staticData.seasonKey
        };
        if (state.staticData.params && state.staticData.params.segment)
            data["segment"] = state.staticData.params.segment;
        if (state.staticData.params && state.staticData.params.p)
            data["pickupSiteKey"] = state.staticData.params.p;
        dispatch(fetchingData(FetchingTypes.LOAD_STORE_DATA));
        return ajax(fetchUrl, data)
            .then(json => {
                if (json.error)
                    throw json.error;
                initialData["staticData"] = state.staticData;
                return storeParser(json, initialData);
            })
            .then(store => {
                dispatch(setStoreCreditsData(store.creditsData));
                dispatch(setSummary(store.summary));
                dispatch(setActiveOrder(store.activeOrder, false));
                dispatch(loadCategories(store.categories));
                dispatch(loadItems(store.items));
                dispatch(setAllowOrderEditFlag());
                dispatch(hasCoupons(store.hasCoupons));
                dispatch(updateItemsAvailabilityFromOrder(store.activeOrder, store.items));
                dispatch(calculateAllTotals());
                dispatch(setMessageData(store.messageData));
                dispatch(setEditMultiOrderFlag());
                if(store.recurringOrder){dispatch(setRecurringOrderData(store.recurringOrder));}
                dispatch(loadDraftItems(store));
                dispatch(checkRemovePath(store));
                dispatch(setShouldReloadData(false));
                dispatch(dataFetched());
                if(state.staticData.isSupportGuestMembers && store.summary.status === SubscriptionStatuses.NO_SUBSCRIPTION) {
                    let path = redirectPage(URLs.JOIN, state.staticData) + "?mode=guest";
                    window.location.assign(path);
                }
            })
            .catch(error => {
                dispatch(errorFetching(error, {action: () => {return function(dispatch){window.location.reload(true)}}, args: []}));
            })
    }
}

export function setAllowOrderEditFlag(){
    return function(dispatch, getStore){
        const state = getStore();
        const orderStatus =  state.orderStatus || {};
        const canEditExisitingOrder = state.staticData.confirmEditExistingOrder ? false : (state.summary || {}).canEditExistingOrder;
        const flag = canEditExisitingOrder === false && orderStatus.activeOrder && Object.keys(orderStatus.activeOrder).length > 0 && !state.orderStatus.isChanged? false : true;
        dispatch(setAllowOrderEditToStore(flag));
    }
}

export function setEditMultiOrderFlag(){
    return function(dispatch, getStore){
        const state = getStore();
        const flag = !(state.staticData.isMultipleActiveOrdersEnabled && state.summary.secondNextDeliveryDate !== undefined);
        dispatch(setEditMultiOrder(flag));
    }
}

//TODO clean path to not include payments nor echeck
export function checkRemovePath() {
    return function (dispatch) {
        let endPath = '';
        if (window.location.pathname.endsWith('pay')) {
            endPath = 'pay';
        } else if (window.location.pathname.endsWith('checkout')) {
            endPath = 'checkout';
        } else if (window.location.pathname.endsWith('thankyou')) {
            endPath = 'thankyou';
        }
        let removedPath = removePath(endPath);
        if (removedPath.startsWith('/store/') && window.location.hash)
            removedPath += window.location.hash;
        dispatch(replace(removedPath));
    }
}

export function getStoreDataAndSubmit(staticData, memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, isChargeOnDelivery) {
    return function (dispatch, getState) {
        const state = getState();
        if(isFetching(state, FetchingTypes.SUBMIT)) {
            return;
        }
        const activeOrder = (state.orderStatus || {}).activeOrder;
        const fetchUrl = '/dispatcher/WebStoreService.getStoreDataMember';
        let data = {
            farmKey: staticData.farmKey,
            memberKey: memberKey,
            seasonKey: staticData.seasonKey
        };
        if (state.staticData.params && state.staticData.params.p)
            data["pickupSiteKey"] = state.staticData.params.p;
        dispatch(fetchingData(FetchingTypes.SUBMIT));
        const skipUnavailableItemsCheck = staticData.updateItemAvailabilityOnItemQuantityChange;
        return ajax(fetchUrl, data)
            .then(json => {
                if (json.error)
                    throw json.error;
                //check store hours if ok then continue else show store close message
                const storeMessageData = getStoreCloseMessage(json.store, state.staticData.storeCloseAdditionalMessage);
                if(storeMessageData && (!state.staticData.isMultipleActiveOrdersEnabled && !state.summary.secondNextDeliveryDate)){
                    dispatch(setDirty(false));
                    dispatch(setMessageData(storeMessageData));
                    dispatch(dataFetched());
                }else{
                    const extraCreditItem = (state.storeCreditsData.extraCreditItem || {});
                    const storeItems = itemsParser(json.store);
                    const itemsDivided = getOrderedItemsForSummary(items, activeOrder, canEditExistingOrder);
                    const editableItems = itemsDivided.editableItems.concat(itemsDivided.creditEditableItems);
                    let unAvailableItems = {};
                    let itemsRemoved = 0;
                    let returnedCredits = 0;

                    if(!skipUnavailableItemsCheck) {
                        for (let i = 0; i < editableItems.length; i++) {
                            let orderItem = editableItems[i];
                            if (orderItem.key === extraCreditItem.key)
                                continue;
                            const storeItem = storeItems[orderItem.key];
                            if (storeItem && storeItem.available < 0) {
                                storeItem.available = 0;
                            }
                            const originItemOrderQuantity = orderItem.quantity;
                            if (!storeItem) {
                                if (activeOrder && activeOrder.hasOwnProperty(orderItem.key)) {
                                    orderItem.quantity = activeOrder[orderItem.key].quantity;
                                } else {
                                    orderItem.quantity = 0;
                                    dispatch(setRecurringItem(orderItem));
                                }
                                orderItem.available = 0;
                                if (originItemOrderQuantity > orderItem.quantity) {
                                    unAvailableItems[orderItem.key] = orderItem;
                                    if (orderItem.isCredit)
                                        returnedCredits += originItemOrderQuantity * orderItem.price - orderItem.quantity * orderItem.price;
                                    itemsRemoved++;
                                }
                            } else if (storeItem.available - orderItem.quantity < 0) {
                                if (activeOrder && activeOrder[orderItem.key]) {
                                    if (orderItem.quantity > (activeOrder[orderItem.key].quantity + storeItem.available)) {
                                        orderItem.quantity = activeOrder[orderItem.key].quantity + storeItem.available;
                                    }
                                } else {
                                    orderItem.quantity = storeItem.available;
                                }

                                orderItem.available = storeItem.available;
                                if (originItemOrderQuantity !== orderItem.quantity) {
                                    unAvailableItems[orderItem.key] = orderItem;
                                    if (orderItem.isCredit)
                                        returnedCredits += originItemOrderQuantity * orderItem.price - orderItem.quantity * orderItem.price;
                                }
                                //storeItem.quantity = storeItem.available
                            }
                        }
                    }
                    if (state.summary.pickupSite.key !== json.subscriptionSummary.pickupSite.key) {
                        dispatch(setDirty(false));
                        dispatch(errorFetching({message:PICKUP_SITE_KEY_CHANGED}));
                    }
                    else if(orderKey !== (json.subscriptionSummary||{}).activeWebOrderKey) {
                        dispatch(setDirty(false));
                        dispatch(errorFetching({message:ORDER_KEY_CHANGED}));
                    } else if(Object.keys(unAvailableItems).length === 0){
                        //all items in the order are available and in store hours store is still open
                        dispatch(submitOrder(memberKey, subscriptionKey, orderKey, items, activeOrder, canEditExistingOrder, hasPreapproval, storeComments, method, isChargeOnDelivery));
                    } else{
                        dispatch(updateItems(unAvailableItems));
                        dispatch(returnCredits(returnedCredits));
                        dispatch(calculateAllTotals());
                        if(editableItems.length === itemsRemoved){
                            //all of the ordered items became unavailable
                            dispatch(setDirty(false));
                        }
                        //dispatch action to show message of unavailable items with their titles do you want to go back to store or confirm the order.
                        dispatch(setUnavailableItemsInOrder(unAvailableItems));
                        dispatch(dataFetched());
                    }
                }
            })
            .catch(error => {
                dispatch(errorFetching(error));
            })
    }
}

export function updateStoreDataAvailability(staticData, categoryKey, items, activeOrder, skipItem) {
    return function (dispatch) {
        const fetchUrl = '/dispatcher/WebStoreService.getStoreDataForCategory';
        let data = {
            farmKey: staticData.farmKey,
            categoryKey: categoryKey
        };
        return ajax(fetchUrl, data)
            .then(json => {
                if (json.error)
                    return;
                const itemsDivided = getOrderedItemsForSummary(items, activeOrder, true);
                const orderItems = Object.entries(itemsDivided).reduce((acc, [key, values]) => {
                    values.forEach(item => {
                        if (!acc[item.key]) {
                            acc[item.key] = item.quantity;
                        }
                    });
                    return acc
                }, {});
                const storeItems = itemsParser(json.store);
                let itemsAvailability = {};

                for (const itemKey in storeItems) {
                    const storeItem = storeItems[itemKey];
                    if (itemKey === skipItem) {
                        continue;
                    }
                    itemsAvailability[storeItem.key] = storeItem;
                    if (orderItems[itemKey]) {
                        itemsAvailability[storeItem.key].available += orderItems[itemKey];
                    }
                }
                dispatch(updateItemsAvailability(itemsAvailability));

            })
            .catch()
    }
}

export function updateStoreItemAvailability(staticData, itemKey, newQuantity, oldQuantity, onComplete) {
    return function (dispatch, getState) {
        const state = getState();
        const fetchUrl = '/dispatcher/WebStoreService.updateStoreItemAvailability';
        const memberKey = (state.memberDetails || {}).key;
        const data = {
            farmKey: staticData.farmKey,
            memberKey: memberKey,
            itemKey: itemKey,
            availabilityChange: oldQuantity - newQuantity
        };
        return ajax(fetchUrl, data)
            .then(available => {
                const itemsAvailability = {};
                if (available < 0) {
                    // Return the current availability
                    itemsAvailability[itemKey] = {available: oldQuantity};
                } else {
                    // Need to include the items in the order in the availability
                    itemsAvailability[itemKey] = {available: available + newQuantity};
                }
                dispatch(updateItemsAvailability(itemsAvailability));
                onComplete(available);
            })
            .catch(() => {
                onComplete(-1);
            })
    }
}

export function updateItems(items){
    return {
        type: UPDATE_ITEMS_PROPS,
        items
    }
}

export function updateItemsAvailability(items){
    return {
        type: UPDATE_ITEMS_AVAILABILITY,
        items
    }
}

function getFetchUrl(memberKey) {
    if(!memberKey) {
        return '/dispatcher/WebStoreService.getStoreDataGuest';
    } else {
        return '/dispatcher/WebStoreService.getStoreDataMember';
    }
}

function storeParser(json, initialData) {
    const items = itemsParser(json.store);
    const creditsData = creditsDataParser(json.store);
    initialData["creditType"] = creditsData.creditType;
    initialData["credits"] = creditsData.credits;
    const subscriptionSummary = subscriptionSummaryParser(json, initialData.staticData);
    let activeOrder;
    let creditQuantity = 0;
	if ((json.activeWebOrder || {}).items) {
		activeOrder = activeOrderParser(json.activeWebOrder, json.activeWebOrder.coupon !== undefined);
		Object.keys(activeOrder.items).forEach(key=>{
			let i = activeOrder.items[key];
			let item = items[i.key];
			if (item) {
				item.orderedQuantity = i.quantity;
				item.quantity = i.quantity;
                item[FIELD_SELECTED_ORDER] = i[FIELD_SELECTED_ORDER];
				item[FIELD_ADDITIONAL_ITEM_QTY] = i[FIELD_ADDITIONAL_ITEM_QTY];
                item.minQuantity = subscriptionSummary.canEditExistingOrder?0:i.quantity;
                items[i.key].price = i.price;
			} else {
				items[i.key] = i;
			}
            if(i.isCredit && i.quantity) {
                creditQuantity += i.quantity*i.price;
            }
		});
        if(creditQuantity > 0)
        {
            let qty = creditsData.credits - creditQuantity;
            if(qty < 0) {
                if(creditsData.extraCreditItem) {items[creditsData.extraCreditItem.key]['quantity'] = -qty;}
                creditsData.remainingCredits = 0;
            } else {
                creditsData.remainingCredits = qty
            }
        }
	}
	//In case the item is not published
	if (initialData.itemKey && !items[initialData.itemKey])
        initialData.itemKey = undefined;
    return {
        items: items,
        categories: json.store.categories ? categoriesParser(json.store, items, initialData.category, initialData.itemKey) : {},
		summary: subscriptionSummary,
		activeOrder: activeOrder,
        messageData: messageDataParser(json.store, initialData),
        itemKey: initialData.itemKey,
        creditsData: creditsData,
        hasCoupons: json.store.hasCoupons,
        recurringOrder: recurringOrderParser(json.recurringOrder, subscriptionSummary.nextDeliveryDate)
    }
}

export function activeOrderParser(activeWebOrder, existingCoupon) {
	function sort(items) {
		return (items||[]).sort((i1, i2)=>i1.title < i2.title ? -1 : (i1.title > i2.title ? 1 : 0));
	}
	if (activeWebOrder) {
		let items = sort(activeWebOrder.items).reduce((prev, curr)=> {
			prev[curr.key] = curr;
			curr[FIELD_SELECTED_ORDER] = increaseItemOrder();
			return prev;
		}, {});
		sort(activeWebOrder.additionalItems).forEach(i=>{
			if (!items[i.key]) {
				items[i.key] = i;
				i[FIELD_SELECTED_ORDER] = increaseItemOrder();
			} else {
				items[i.key].quantity+=i.quantity;
			}
			items[i.key][FIELD_ADDITIONAL_ITEM_QTY] = i.quantity;
		});
		return {
			items: items,
			orderKey: activeWebOrder.key,
            comments: activeWebOrder.comments,
            coupon: parseCouponData(activeWebOrder.coupon, existingCoupon),
            usedFarmigoCredits:activeWebOrder.usedFarmigoCredits
		}
	}
	return undefined;
}

function categoriesParser(json, items, initialCategory, initialItem) {
    if(initialItem){
        initialCategory = items[initialItem].category;
    }
    let nonEmptyCategories = {};
    const extraCreditItemKey = (json.extraCreditItem || {}).key;
    for (let key in items){
        if(items.hasOwnProperty(key) && key !== extraCreditItemKey) {
            nonEmptyCategories[items[key].category] = true;
            for (const category of (items[key].additionalCategories || [])) {
                nonEmptyCategories[category] = true;
            }
        }
    }
    const categories = json.categories.map((c)=> {return {
        key: c.key,
        title: c.title,
        order: c.order,
        selected: c.key === initialCategory
    }})
        .filter(c=>nonEmptyCategories[c.key])
        .sort((c1, c2)=>c1.order-c2.order);
    if (!initialCategory && categories.length > 0)
        categories[0].selected = true;
    return categories;
}

function itemsParser(json) {
    let items = {};
    if(!json.items) {
        return items;
    }
    json.items.map(function (item) {
        let itemProp = {};
        itemProp['key'] = item.key;
        itemProp['quantity'] = 0;
        itemProp['orderedQuantity'] = /*item.unitQuantity*/ 0;
        itemProp['title'] = item.title;
        itemProp['label'] = item.label;
        itemProp['points'] = item.points;
        itemProp['price'] = item.price;
        itemProp['salesTax'] = item.salesTax;
        itemProp['imageUrl'] = item.imageUrl;
        itemProp['producerTitle'] = item.producer ? item.producer.title : "";
        itemProp['producerKey'] = item.producer ? item.producer.key : undefined;
        itemProp['unit'] = item.unit;
        itemProp['unitQuantity'] = item.unitQuantity;
        itemProp['discount'] = item.discount;
        itemProp['isCredit'] = item.isCredit;
        itemProp['description'] = item.description?item.description.replace(/\r/g,'<br>'):'';
        itemProp['category'] = item.category;
        itemProp['additionalCategories'] = item.additionalCategories || [];
        itemProp['producer'] = item.producer;
        itemProp['maxPerMember'] = item.maxPerMember;
        itemProp['available'] = item.available;
        if (item.variations && item.variations.length) {
			let variations = [];
			if (item.variations.length === 1) {
				if (itemProp["key"] !== item.variations[0].key) {
					itemProp = Object.assign(itemProp, item.variations[0]);
				}
			} else {
				itemProp['key'] = itemProp['key']+'_parent';
				itemProp['available'] = itemProp['available'] || 1;
				item.variations.forEach(v=>{
					const variation = Object.assign({variation: true, defaultBoxItem: itemProp['key']}, itemProp, v);
					variations.push(variation);
					items[v.key] = variation;
				});
				itemProp['variations'] = variations;
			}
		}
        items[itemProp.key] = itemProp;
    });
    if(json.extraCreditItem) {
        let item = json.extraCreditItem;
        item['quantity'] = 0;
        item['orderedQuantity'] = 0;
        item['available'] = false;
        items[item.key] = item;
    }
    return items;
}

function creditsDataParser(json) {
    let store = (json || {});
    let creditType = store.creditType;
    if((creditType === CreditTypes.CREDIT_TYPE_REGULAR || store.holdReason === SubscriptionHoldReason.NEW)
        && json.items.filter(item => {return item.isCredit}).length > 0){
        creditType = CreditTypes.CREDIT_BY_SHARE;
    }
    return {
        creditType: creditType,
        credits: store.credits,
        deliveryDate: store.deliveryDate,
        extraCreditItem: store.extraCreditItem,
        remainingCredits: store.credits,
        usedFarmigoCredits: store.usedFarmigoCredits,
        balanceAsCredits: store.balanceAsCredits
    }
}

export function calculateAllTotals(){
    return function(dispatch, getState){
        dispatch(calculateOrdersTotals(getState().itemsList));
    }
}

export function calculateOrdersTotals(items){
    return function(dispatch, getState){
        const state = getState();
        const orderStatus = state.orderStatus || {};
        const summary = (state.summary || {});
        const activeOrder = orderStatus.activeOrder;
        const canEditExistingOrder = summary.canEditExistingOrder;
        const extraCost = summary.extraCost;
        const extraCostType = summary.extraCostType;
        const totalUsedFarmigoCredits = (state.storeCreditsData || {}).usedFarmigoCredits;
        const balanceAsCredits = (state.storeCreditsData || {}).balanceAsCredits;
        const credits = (state.storeCreditsData || {}).credits;
        const extraCreditItemKey = ((state.storeCreditsData || {}).extraCreditItem || {}).key;
        const staticData = state.staticData;
        const couponValue = (orderStatus.coupon||{}).discount;
        const hasAlreadyCoupon = orderStatus.existingCoupon;
        let totals = {};

        const orderedItems = getOrderedItemsForSummary(items, activeOrder, canEditExistingOrder )
            ||{
                filteredItems:[],
                fixedItems:[],
                editableItems:[],
                creditFilteredItems:[],
                creditFixedItems:[],
                creditEditableItems:[]
            };

        const hasFixedItems = orderedItems.fixedItems.length;
        if(orderedItems.creditFilteredItems.length){
            totals.creditsTotal = orderedItems.creditFilteredItems.reduce(function(total, item) {
                return total + (item.price*item.quantity);
            },0);
            if(hasFixedItems) {
                totals.creditFixedItems = orderedItems.creditFixedItems.reduce(function(total, item) {
                    return total + (item.price * item.quantity);
                }, 0);
            }
            if(orderedItems.creditEditableItems && orderedItems.creditEditableItems.length > 0) {
                totals.creditEditableItems = orderedItems.creditEditableItems.reduce(function (total, item) {
                    return total + (item.price * item.quantity);
                }, 0);
            }
        }
        totals.orderTotal = calculateOrderTotal(orderedItems.filteredItems, {extraCost, extraCostType,
            credits: credits && totalUsedFarmigoCredits? credits - totalUsedFarmigoCredits: credits,
            couponValue, balanceAsCredits, extraCreditItemKey,
            creditsTotal: totals.creditsTotal}, staticData);
        if (hasFixedItems) {
            totals.fixedTotal = calculateOrderTotal(orderedItems.fixedItems,{extraCost, extraCostType,
                credits: credits && orderStatus.usedFarmigoCredits? credits - orderStatus.usedFarmigoCredits: credits,
                couponValue: hasAlreadyCoupon?couponValue:undefined, balanceAsCredits, extraCreditItemKey,
                creditsTotal: totals.creditsTotal}, staticData);
        }
        if (orderedItems.editableItems.length) {
            totals.editableTotal = calculateOrderTotal(orderedItems.editableItems,
                {extraCost: hasFixedItems ? undefined: extraCost,
                    extraCostType: hasFixedItems ? undefined: extraCostType,
                    credits: credits && totalUsedFarmigoCredits? credits - totalUsedFarmigoCredits: credits,
                    couponValue: (!hasFixedItems || !hasAlreadyCoupon) && couponValue?couponValue:undefined,
                    balanceAsCredits, extraCreditItemKey,
                    creditsTotal: totals.creditsTotal
                },
                staticData);
        }
        if (staticData.showItemPoints) {
            totals.points = calculateOrderPoints(orderedItems.filteredItems);
        }
        dispatch(updateTotals(orderedItems, totals));
    }
}

export function updateTotals(orderedItems, totals){
    return {
        type: UPDATE_TOTALS,
        orderedItems,
        totals
    }
}

export function updateItemsAvailabilityFromOrder(activeOrder, items){
    return function(dispatch, getState){
        const state = getState();
        const staticData = state.staticData;
        if (staticData.updateItemAvailabilityOnItemQuantityChange && activeOrder) {
            const extraCreditItem = (state.storeCreditsData.extraCreditItem || {});
            let itemsAvailability = {};
            const orderItems = activeOrder.items || [];
            for (const itemKey in orderItems) {
                const orderItem = orderItems[itemKey];
                itemsAvailability[itemKey] = items[itemKey];
                if (items[itemKey] && itemKey !== extraCreditItem.key) {
                    itemsAvailability[itemKey].available += orderItem.quantity;
                }
            }
            dispatch(updateItemsAvailability(itemsAvailability));
        }
    }
}

function returnCredits(returnedCredits){
    return function(dispatch, getState){
        const state = getState();
        const creditsData = (state.storeCreditsData || {});
        let extraCreditsCount = creditsData.extraCreditItem ? creditsData.extraCreditItem.quantity : 0;

        if (returnedCredits === 0)
            return;

        if (extraCreditsCount > 0) {
            //First reduce credits from extra credit item
            const extraCreditsNewQuantity = (extraCreditsCount - returnedCredits) >= 0 ? (extraCreditsCount - returnedCredits) : 0;
            dispatch(changeItemQuantityAction(creditsData.extraCreditItem.key, extraCreditsNewQuantity));
            dispatch(changeExtraItemQuantityAction(creditsData.extraCreditItem.key, extraCreditsNewQuantity));
        }

        if ((extraCreditsCount - returnedCredits) < 0){
            //Then increase the remaining credits balance
            let remainingCredits = creditsData.remainingCredits + returnedCredits - extraCreditsCount;
            dispatch(setStoreCreditsRemaining(remainingCredits));
        }
    }
}
export function hasCoupons(hasCoupons) {
    return {
        type: SET_STORE_HAS_COUPONS,
        hasCoupons
    }
}
export function hasAlreadyCoupon(hasAlreadyCoupon) {
    return {
        type: SET_HAS_ALREADY_COUPON,
        hasAlreadyCoupon
    }
}
export function applyCoupon(couponId){
    return function(dispatch){
        if(couponId === ""){
            dispatch(setCoupon(undefined));
        } else {
            dispatch(getCouponData(couponId, setCouponAndUpdateSummary));
        }
    }
}
export function setCouponAndUpdateSummary(coupon) {
    return function (dispatch) {
        dispatch(setCoupon(coupon));
        dispatch(calculateAllTotals());
    }
}
export function setCoupon(coupon) {
    return {
        type: SET_WEB_ORDER_COUPON,
        coupon
    }
}


// WEBPACK FOOTER //
// ./src/actions/store/storeActions.js